// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"15":"40828a64","306":"c69e6033","451":"548da40c","762":"4841bc8b","907":"6e84dd52"}[chunkId] + ".chunk.css";
};